import { DateTime } from "luxon"
import { MonetaryAmount } from "../../../currency/currencyTypes"
import { Dinero } from "dinero.js"

export enum FeeType {
    PAYMENT = "PAYMENT",
    TRANSFER = "TRANSFER",
    REFUND = "REFUND",
}

type SupplierAcquiringReportsMerchant = Readonly<{
    id: number
    name: string
    caseNumber?: string
}>

export type FeeItem = Readonly<{
    id: number
    pspPaymentMerchantReference?: number
    pspPaymentPspReference: string
    bookingDate: string
    valueDate: string
    type: FeeType
    amount: MonetaryAmount
    merchant?: SupplierAcquiringReportsMerchant
    balanceAccount: string
}>

export type TransferItem = Readonly<{
    transferId: number
    bookingDate: string
    valueDate: string
    amount: MonetaryAmount
    merchant?: SupplierAcquiringReportsMerchant
    balanceAccount: string
    bankAccount: {
        accountIdentifier: string
    }
}>

export type BalanceAccount = Readonly<{
    id: string
    merchants: BalanceAccountMerchant[]
}>

export type BalanceAccountMerchant = {
    id: number
    name: string
    caseNumber?: string
}

export enum DateType {
    BOOKING_DATE = "BOOKING_DATE",
    VALUE_DATE = "VALUE_DATE",
}

// Balance
export enum AcquiringReportType {
    POSTING = "POSTING",
    TOTAL = "TOTAL",
    BALANCE = "BALANCE",
}
export type AcquiringReport = Readonly<{
    type: AcquiringReportType
    name: string
    amount: MonetaryAmount
}>
export enum BalanceSelectOrderType {
    NET_SALES = "NET_SALES",
    BANK_TRANSFERS = "BANK_TRANSFERS",
    BALANCE = "BALANCE",
}

export enum RevenueType {
    BANK_TRANSFER = "BANK_TRANSFER",
    /** Revenue received in a previous accounting period but transferred in the current. */
    PREVIOUS_REVENUE = "PREVIOUS_REVENUE",
    /** Revenue from sales in a previous accounting period but received in the current. */
    DEFERRED_REVENUE = "DEFERRED_REVENUE",
    /** Normal revenue earned and received inside the current accounting period. */
    NORMAL_REVENUE = "NORMAL_REVENUE",
    /** Revenue earned in the current accounting period but not received in it. */
    ACCRUED_REVENUE = "ACCRUED_REVENUE",
}

export enum TransferType {
    /** Included in transfers  */
    INCLUDED,
    EXCLUDED,
}

export type BalancePaymentDetails = Readonly<{
    orderId: number
    orderCreated: string
    pspPaymentReference: string
    bookingDate: string
    valueDate?: string
    grossAmount: MonetaryAmount | undefined
    netAmount: MonetaryAmount | undefined
    feeAmount: MonetaryAmount | undefined
}>

export type ParsedPaymentDetails = Readonly<{
    orderId: number
    orderCreated: string
    pspPaymentReference: string
    bookingDate: DateTime
    valueDate: DateTime | undefined
    grossAmount: Dinero<number> | undefined
    netAmount: Dinero<number> | undefined
    feeAmount: Dinero<number> | undefined
    effectiveAmount: Dinero<number> | undefined
    type: RevenueType | undefined
}>

export type PaymentDetailsSplit = Readonly<{
    bankTransfers: ParsedPaymentDetails[]
    deferred: ParsedPaymentDetails[]
    normal: ParsedPaymentDetails[]
}>

export type PaymentForPeriod = Readonly<{
    orderId: number
    orderCreated: string
    pspPaymentReference: string
    bookingDate: string
    valueDate: string
    grossAmount: MonetaryAmount
    netAmount: MonetaryAmount
    feeAmount: MonetaryAmount
}>
